import { TOASTS_WRAPPER_ELEMENT_ID } from 'frontcore/presentation/alert/domain/constants'

type ClickOutsideCallback = (event: MouseEvent) => void
type ClickOutsideEvent = (event: MouseEvent) => void
type DirectiveBinding = { value: unknown }

class DirectiveClickOutsideError extends Error {}

const isClickOutsideCallback = (o: unknown): o is ClickOutsideCallback => o instanceof Function
const isHTMLElement = (o: unknown): o is HTMLElement => o instanceof Element

const events: WeakMap<HTMLElement, ClickOutsideEvent> = new WeakMap()
const clickOutsideEvent = (element: HTMLElement, callback: ClickOutsideCallback) => (event: MouseEvent) => {
  const target = event.target
  const toastWrapperElement = document.getElementById(TOASTS_WRAPPER_ELEMENT_ID)
  if (!isHTMLElement(target) || element.contains(target) || toastWrapperElement?.contains(target)) { return }
  callback(event)
}

export const clickOutsideBind = (element: HTMLElement, { value }: DirectiveBinding) => {
  if (!isClickOutsideCallback(value)) { throw new DirectiveClickOutsideError() }
  const event = clickOutsideEvent(element, value)
  events.set(element, event)
  document.addEventListener('click', event, true)
}

export const clickOutsideUnbind = (element: HTMLElement) => {
  const event = events.get(element)
  if (event === undefined) { return }
  events.delete(element)
  document.removeEventListener('click', event, true)
}
